
import Workflow from 'src/compass/assets/Claim Tracking Workflow.jpg';

export default function WorkflowTab() {

  return (    
    <>
      <h2>Claim Tracking workflow diagram</h2>
      <img src={Workflow} alt="Claim Tracking Workflow" />    
    </>
      
  );
}
